import React from "react";
import UploadImg from "./UploadImg";
import ProductImage from "./ProductImage";

const ShowOrUploadImg = ({ hasImage, operationType = undefined, isDirty, itemId, aziendaid, label, table }) => {
  return hasImage ? (
    <div className="flex flex-column w-5 align-items-center  justify-content-center ">
      <ProductImage
        aziendaId={aziendaid}
        itemId={itemId}
        table={table}
        label={label}
        operationType={operationType}
        isDirty={isDirty}
        hasImage={hasImage}
      />
    </div>
  ) : (
    operationType === "A" ||
      (operationType === "U" && (
        <div className="flex w-full align-items-center">
          <UploadImg itemId={itemId} aziendaId={aziendaid} label={label} table={table} isDirty={isDirty} />
        </div>
      ))
  );
};

export default ShowOrUploadImg;
